// Overlapping-avatar "face stack" — e.g. "3 avatars + N" for who's done
// today's devotional, or who's going to an event. Self-contained (doesn't
// import BibleApp.jsx's Avatar, which isn't exported — small per-file
// helpers are the existing convention in this codebase).

import { CIRCLE_PASTELS } from "./ExploreTab";

function getInitials(name) {
  return (name || '')
    .split(/\s+/).filter(Boolean).slice(0, 2)
    .map(w => w[0].toUpperCase()).join('') || '·'
}

// Same user always gets the same pastel — hashed off their id, not their
// name (so it doesn't shift if they rename), same hash shape used for
// avatar pastels elsewhere in the app (e.g. FullSermonSheet's church pastel).
function pastelForUser(id) {
  const key = String(id || '')
  let hash = 0
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0
  return CIRCLE_PASTELS[hash % CIRCLE_PASTELS.length]
}

function Face({ id, url, name, size, overlap, ringColor }) {
  const sz = { width: size, height: size, borderRadius: '50%', flexShrink: 0 }
  const border = { border: `1.5px solid ${ringColor}`, marginLeft: overlap ? -size * 0.3 : 0 }
  if (url) {
    return <img src={url} alt="" loading="lazy" style={{ ...sz, ...border, objectFit: 'cover', display: 'block' }}/>
  }
  const pastel = pastelForUser(id)
  return (
    <div style={{
      ...sz, ...border,
      background: pastel.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: Math.max(10, Math.round(size * 0.34)),
      fontWeight: 800, color: pastel.ink, letterSpacing: '0.02em',
    }}>
      {getInitials(name)}
    </div>
  )
}

// userIds: array of ids to render, in order. profilesById: { [id]: { full_name, avatar_url } }.
// ringColor: the border colour each face (and the "+n" bubble) is cut out
// against — default is the app's paper/white background; pass the host
// surface's own colour (e.g. "#E8C87A" on the gold plan strip) so faces
// read as cut into that surface rather than outlined on top of it.
export default function FaceStack({ userIds = [], profilesById = {}, max = 3, size = 26, ringColor = 'var(--paper, var(--white))' }) {
  if (!userIds.length) return null
  const shown = userIds.slice(0, max)
  const extra = userIds.length - shown.length
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {shown.map((id, i) => {
        const p = profilesById[id]
        return <Face key={id} id={id} url={p?.avatar_url} name={p?.full_name} size={size} overlap={i > 0} ringColor={ringColor}/>
      })}
      {extra > 0 && (
        <div style={{
          width: size, height: size, borderRadius: '50%', marginLeft: -size * 0.3,
          border: `1.5px solid ${ringColor}`, background: 'var(--stone)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: Math.max(10, Math.round(size * 0.32)), fontWeight: 800, color: 'var(--white)',
        }}>
          +{extra}
        </div>
      )}
    </div>
  )
}
